var Vendd = (function (Vendd) {
    "use strict";

    Vendd.CancelOrder = (function (CancelOrder) {

        Vendd.MessageBus.subscribe(Vendd.CancelOrder.Messages.CancelOrder, Vendd.CancelOrder, function (envelope) {

            var options = {
                url: 'api/CancelOrder/CancelOrder',
                data: envelope.message.data,
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            function onSuccess(response) {
                if (response.success) {
                    Vendd.MessageBus.publishAsync(Vendd.CancelOrder, new Vendd.CancelOrder.Messages.CancelOrderSuccess(response));
                } else {
                    Vendd.MessageBus.publishAsync(Vendd.CancelOrder, new Vendd.CancelOrder.Messages.CancelOrderFailure(response));
                }
            }

            function onFailure(response) {
                Vendd.MessageBus.publishAsync(Vendd.CancelOrder, new Vendd.CancelOrder.Messages.CancelOrderError(response));
            }

            Vendd.Service.call(options);
        });

        return CancelOrder;
    })(Vendd.CancelOrder || {});

    return Vendd;
})(Vendd || {});
